"use client";
import { AuthenticationResult, AuthError, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, b2cMsalConfig } from "authConfig";
import { MSAL_LOGIN_ERROR_STORAGE_NAME } from "clientConst";


export const MsalInstanceFactory = (isB2C: boolean = false) => {
    const msalInstance = isB2C ? new PublicClientApplication(b2cMsalConfig) : new PublicClientApplication(msalConfig);

    msalInstance.initialize().then(() => {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        const accounts = msalInstance.getAllAccounts();

        if (!msalInstance.getActiveAccount() && accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        const callbackId = msalInstance.addEventCallback((event: EventMessage) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
                const payload = event.payload as AuthenticationResult;
                const account = payload.account;
                msalInstance.setActiveAccount(account);
            }

            if (event.eventType === EventType.LOGIN_FAILURE) {
                // Without this, a real B2C/AAD error here looks identical to the
                // normal "not signed in yet" redirect to /login - there's no
                // account either way. Surface it so it's distinguishable.
                const message = (event.error instanceof AuthError ? event.error.errorMessage : event.error?.message) || "Sign-in failed";
                console.error("MSAL login failure:", event.error);
                if (typeof window !== "undefined") {
                    window.sessionStorage.setItem(MSAL_LOGIN_ERROR_STORAGE_NAME, message);
                }
            }
        });

        return () => {
            if (callbackId) {
                msalInstance.removeEventCallback(callbackId);
            }
        };
    });
    return msalInstance;
};